import React, { createContext } from "react";

import Link from "../json/link.json";

export const LinkContext = createContext();

const LinkContextProvider = (props) => {
  const al = Link;

  return (
    <LinkContext.Provider value={{ al }}>{props.children}</LinkContext.Provider>
  );
};

export default LinkContextProvider;
